import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GlobalComponent } from 'src/app/global/global.component';
import { LoginComponent } from '../../login/login.component';
import { loginBO } from '../onboarding.model';
import { onboardingservice } from '../onboarding.service';

@Component({
  selector: 'app-onboarding-login',
  templateUrl: './onboarding-login.component.html',
  styleUrls: ['./onboarding-login.component.scss']
})
export class OnboardingLoginComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  signin: loginBO = new loginBO();
  LoginForm: FormGroup;
  forgotLoginForm: FormGroup
  page: string = 'login'
  currentUrl: any
  statusERR="";
  show_pass:boolean=false;
  currentUrlStringArray: any = [];
  Password:any;
  @Output() newItemEvent = new EventEmitter<string>();
  constructor(public toastrService: ToastrService, public http: HttpClient, public RegisterhttpService: onboardingservice, 
    private formBuilder: FormBuilder, public route: Router, public global: GlobalComponent,
    private ngxLoader: NgxUiLoaderService) 
    {
    this.LoginForm = this.formBuilder.group({
      Email: ['', Validators.required],
      WebPassword: ['', Validators.required],
     // agencycode: ['', Validators.required],
    }
    );
    this.forgotLoginForm = this.formBuilder.group({
      uname: ['', [Validators.required, Validators.email]],
      // email: ['', [Validators.required, Validators.email,Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
      password: ['', [Validators.required, Validators.minLength(8)]],
      Confirm_password: ['', [Validators.required]],
      // CustomValidators.mustMatch('password', 'confirmPassword'),
    },
      // {
      //   validator: ConfirmedValidator('password', 'Confirm_password')
      // }
    );
  }
  employeelogin: Boolean = false;
  clientlogin: Boolean = false;
  ngOnInit(): void {
    var url = window.location.href;
     
    this.employeelogin = url.includes('/onboarding/employee');
    this.clientlogin = url.includes('/onboarding/client');
    this.Password = 'password'
  }

  get loginForm() {
      return this.LoginForm.controls;
  }


  MoveToNextPage(page: string) {
    this.page = page;
    this.newItemEvent.emit(this.page);
  }
  login() {
    this.ngxLoader.start()

    // this.global.agencyCode="";

 
    

    if (this.LoginForm.get('Email').value == "client" && this.LoginForm.get('WebPassword').value == "client" 
   && this.global.LoginTypeFields != 'employee') {
      var data;
      localStorage.setItem("fms_login", JSON.stringify(data));
      this.route.navigate(['/client-onboarding']);
      this.ngxLoader.stop()
    }
    else if (this.LoginForm.get('Email').value == "employee" && this.LoginForm.get('WebPassword').value == "employee"
     && this.global.LoginTypeFields == 'employee') {
      var data;
      localStorage.setItem("fms_login", JSON.stringify(data));
      this.route.navigate(['/employee-onboarding']);
      this.ngxLoader.stop()
    }
    else {
      this.toastrService.error(
        "",
        "Invalid Credentials",
      );

      setTimeout(() => {
        this.toastrService.clear()
      }, 8000);
      this.ngxLoader.stop()
    }
  }
  OnboardLoginFunction() {
    this.signin.type = this.global.OnboardType
    this.signin.agencyCode=this.global.portalAgencyCode
    this.RegisterhttpService.OnboardLoginAuthentication(this.signin).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.global.LoginUserType = 'Onboard'
      this.global.agencyCode='onboarding'
      data.LoginUserType = 'Onboard';
      // 
      localStorage.setItem("onboardLoginUserName", this.signin.userName);
      localStorage.setItem("fms_login", JSON.stringify(data));
      this.global.authtoken = data.accessToken;
      let refreshData = JSON.parse(localStorage.getItem("fms_refreshtoken "));
      this.global.refreshTokenString = refreshData;
      this.global.onboardingId = data.onboardingId;
      //localStorage.setItem("fms_onboardusername", this.signin.email);
      this.global.OnboardingLoginType = "onboardLogin";
      localStorage.setItem("fms_checkType", this.global.OnboardingLoginType);
      localStorage.setItem("fms_agencyCode", this.global.agencyCode);
      this.global.globalAgencyId = data.agencyId
      // this.global.Adddata(data)
      this.global.assignOnboardingToken(data);
      if (this.clientlogin != false && this.employeelogin == false) {
        this.getClientSideMenus();
        localStorage.setItem("onboardLoginUser",this.global.OnboardType );
      }
      else if (this.clientlogin == false && this.employeelogin != false) {
        this.getEmployeeSideMenus();
        localStorage.setItem("onboardLoginUser",this.global.OnboardType );
      }

    },
      (err: any) => {
        if (err) {
          this.statusERR=err
          this.toastrService.error(err, 'Error'), 8000;
        }
      })
  }

  // ....................................getClientSideMenus.............................................................
  getClientSideMenus() {
    this.RegisterhttpService.getsideMenuforClientOnboarding().subscribe((data: any) => {
      this.setMenudata(data);
      localStorage.setItem("fms_sidebars", JSON.stringify(data));
    },
      (err: any) => {
        if (err) {
          this.toastrService.error(err, 'Error'), 8000;
        }
      })
  }
  // .................................getEmployeeSideMenus..........................................................
  getEmployeeSideMenus() {
    this.RegisterhttpService.getsideMenuforEmployeeOnboarding().subscribe((data: any) => {
      this.setMenudata(data);
      localStorage.setItem("fms_sidebars", JSON.stringify(data));
    },
      (err: any) => {
        if (err) {

          this.toastrService.error(err, 'Error'), 8000;
        }
      })
  }
  // ................................setMenudata.......................................................................
  setMenudata(data) {
    
    let menu: any = []
    let i: number = 1;
    data.forEach(element => {
      let temp: any = {}
      temp.id = i;
      temp.title = element.title;
      temp.routerLink = element.routerLink;
      temp.href = null;
      temp.icon = element.icon;
      temp.target = null;
      temp.parentId = 0;
      if (element.children != null && element.children.length > 0) {
        let j: number = i + 1;
        element.children.forEach(element => {
          let submenu: any = {}
          submenu.id = j;
          submenu.title = element.title;
          submenu.routerLink = element.routerLink;
          submenu.href = null;
          submenu.icon = element.icon != undefined ? element.icon : null;
          submenu.target = null;
          submenu.hasSubMenu = false;
          submenu.parentId = i;
          menu.push(submenu);
          j++;
        });
        i = j - 1;
        temp.hasSubMenu = true;
      }
      else {
        temp.hasSubMenu = false;
      }
      menu.push(temp);
      i++;
    });
    this.global.sideMenuItems = menu;
    localStorage.setItem("fms_menulist", JSON.stringify(this.global.sideMenuItems));
    if (this.clientlogin != false && this.employeelogin == false) {
      this.route.navigate(['/client-onboarding-list']);
      this.global.isClientOnboard=true
    }
    else if (this.clientlogin == false && this.employeelogin != false) {
      this.route.navigate(['/employee-agreementlist']);
      this.global.isClientOnboard=false
    }
    this.toastrService.success('Login Successful')
  }

  showPassWord(){
    this.show_pass=!this.show_pass;
  let val = document.getElementById('bi-ico');
  return (this.show_pass ? this.Password ='text' : this.Password ='password');
  }
  
}

